import React from "react";

import { useNavigate } from "react-router-dom";
import { GenericImageConfig } from "../GenericImageComponent/GenericImageComponent";

import { ExpandedPlaylistHeader } from "../../Features/ExpandedPlaylist/ExpandedPlaylistHeader";

import "./PlaylistCard.css";

/* eslint-disable react/no-unused-prop-types */
export interface PlaylistCardConfig {
  playlistId: string;
  playlistName: string;
  playlistDescription: string;
  playlistAuthorProfilePic: GenericImageConfig;
  playlistAuthorUserHandle: string;
}
/* eslint-enable react/no-unused-prop-types */

export function PlaylistCard(props: PlaylistCardConfig): JSX.Element {
  const navigate = useNavigate();
  const navigateToPlaylistPage = () =>
    navigate(
      `/@${props.playlistAuthorUserHandle}/playlists/${props.playlistId}`
    );
  return (
    <button
      type="button"
      className="playlist-card-button"
      onClick={navigateToPlaylistPage}
    >
      {ExpandedPlaylistHeader({ ...props })}
    </button>
  );
}
